

import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from 'components/CustomButtons/Button.jsx'
import { checkEmancipation } from './functions'
import { Button as ButtonMui } from 'components/storybook'

export function AlertPhoneNumber({ hideAlert, onConfirm, themeColor, open }) {

    return (
        <Modal
            open={open}
            onClick={hideAlert}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ backdropFilter: 'blur(2px)' }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    maxWidth: 470,
                    bgcolor: '#FFFFFF',
                    p: '10px',
                    pb: '20px',
                    borderRadius: '10px',
                    gap: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >

                <Box display="flex " width="100%" justifyContent="flex-end" >
                    <Button
                        color="danger"
                        size="sm"
                        style={{ height: "40px", }}
                        onClick={hideAlert}
                    >
                        Fechar
                    </Button>
                </Box>
                <Box component="a" className='icon-informacao' color="#ffb273" fontSize="70px" />
                <Box textAlign="center" display="flex" flexDirection="column" gap="15px" alignItems={"center"} justifyContent={"center"}>
                    <Typography className="title">
                        Você ainda não validou o celular cadastrado para o login
                        informado.
                    </Typography>
                    <Box className="description">
                        <Typography variant='body1'>
                            Será enviado um novo sms com o código de confirmação
                            para você.
                        </Typography>
                        <Typography variant='body2' fontSize={'12px'}>
                            Clique em 'continuar' para prosseguir com a
                            validação do seu cadastro.
                        </Typography>
                    </Box>

                    <Box width='200px' >
                        <ButtonMui
                            defaultColor={themeColor?.navigation?.buttons?.backgroundColor}
                            outlined="outlined"
                            text={"Continuar"}
                            textColor="#FFFFFF"
                            typeVariation="CustomTextButton"
                            borderRadius="5px"
                            onClick={onConfirm}
                        />
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}

